import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=e518ad30&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=js"
export * from "./ProductView.vue?vue&type=script&lang=js"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=e518ad30&prod&scoped=true&lang=css"
import style1 from "./ProductView.vue?vue&type=style&index=1&id=e518ad30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e518ad30",
  null
  
)

export default component.exports